module.exports = __webpack_public_path__ + "img/mineVipHead.93dbe086.png";